module.exports = __webpack_public_path__ + "static/media/marc-olivier-jodoin.0b12e749.jpg";